import { Spinner } from "@fieldbook/ui/spinner"
import { Outlet, createFileRoute } from "@tanstack/react-router"
import { Suspense } from "react"

function AuthLayout() {
  return (
    <div className="flex h-full min-h-0 flex-col pt-6">
      <main className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </main>
      <footer className="w-full shrink-0 pb-[var(--sai-bottom)] shadow-sm">
        <div className="flex w-full justify-end gap-2 px-2 py-4 sm:px-3 lg:px-5">
          <p className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()}{" "}
            <a href="https://fieldworklabs.xyz">Fieldwork Labs</a>
          </p>
          <p className="text-sm text-gray-500 underline">
            <a
              href={`${import.meta.env.VITE_WEB_APP_URL}/privacy`}
              target="_blank"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </footer>
    </div>
  )
}

export const Route = createFileRoute("/auth")({
  component: () => (
    <Suspense
      fallback={
        <div className="px-auto mx-auto h-screen">
          <Spinner size={"large"} />
        </div>
      }
    >
      <AuthLayout />
    </Suspense>
  ),
})
